var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SidebarMenu',{staticClass:"should-be-sidebar",on:{"toggle":_vm.toggleSidebar}}),_c('router-view',{class:{'sidebar__active': !_vm.sidebarClosed },attrs:{"id":"routerview"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }